<template>
  <em style="display: block" :class="classes" @click="passMethod('click')">
    <slot></slot>
  </em>
</template>

<script>
import themeMixins from '@mixins/officialStore/themeMixins'
export default {
  mixins: [themeMixins]
}
</script>
